export const BULK_PICKUP_REASON = {
  loggedInEligible: "loggedInEligible",
  bulkServiceNotFoundFromSOS: "bulkServiceNotFoundFromSOS",
  billedToCustomerIdNotFound: "billedToCustomerIdNotFound",
  bulkUnavailable: "bulkUnavailable",
  customerNotActive: "customerNotActive",
  badPayCustomer: "badPayCustomer",
  cityBilledAndFranchise: "cityBilledAndFranchise",
  customerNotResidential: "customerNotResidential",
  knowledgeOnly:
    "master consumption flag is either Lost Zone/Archived/N/Knowledge Only",
}

export const CONTAINER_ISSUE_USECASETYPE = {
  loggedInEligible: "loggedInEligible",
  commercialROCustomer: "commercial/ro_customer",
  defaultExceptionMessageHandling: "default_exception_message_handling",
  knowledgeOnly: "knowledge_only",
  hoaStatusIneligible: "hoa_status_ineligible",
  contactAgent: "contact_agent",
  contactCity: "contact_city",
  servicesNotOffered: "services_not_offered",
  lostContract: "lost_contract",
  inactiveBadpay: "inactive_badpay",
  inactiveVacationHold: "inactive_vacation_hold",
  equipmentTypeIneligible: "equipment_type_ineligible",
  equipmentOwnershipStatusIneligible: "equipment_ownership_status_ineligible",
}

export const BULK_ERROR_EXCEPTION_MSG = {
  allotmentExceeded: "allotmentExceeded",
  schedulingError: `schedulingError`,
}
